import Item from './Item.vue';

export default Item;



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/components/score/components/item/index.ts